tinymce.addI18n("ca", {
    "#": "#",
    "Accessibility": "Accessibilitat",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Acci\xf3",
    "Activity": "Activitat",
    "Address": "Adre\xe7a",
    "Advanced": "Avan\xe7ades",
    "Align": "Alinea",
    "Align center": "Alinea al centre",
    "Align left": "Alinea a l'esquerra",
    "Align right": "Alinea a la dreta",
    "Alignment": "Alineaci\xf3",
    "Alignment {0}": "",
    "All": "Tot",
    "Alternative description": "Descripci\xf3 alternativa",
    "Alternative source": "Font alternativa",
    "Alternative source URL": "URL de font alternativa",
    "Anchor": "\xc0ncora",
    "Anchor...": "Ancoratge...",
    "Anchors": "\xc0ncores",
    "Animals and Nature": "Animals i natura",
    "Arrows": "Fletxes",
    "B": "B",
    "Background color": "Color de fons",
    "Background color {0}": "",
    "Black": "Negre",
    "Block": "Bloc",
    "Block {0}": "",
    "Blockquote": "Cita",
    "Blocks": "Blocs",
    "Blue": "Blau",
    "Blue component": "Component blau",
    "Body": "Cos",
    "Bold": "Negreta",
    "Border": "Vora",
    "Border color": "Color de la vora",
    "Border style": "Estil de la vora",
    "Border width": "Amplada de la vora",
    "Bottom": "Part inferior",
    "Browse files": "",
    "Browse for an image": "Explorar per cercar una imatge",
    "Browse links": "",
    "Bullet list": "Llista no ordenada",
    "Cancel": "Cancel\xb7lar",
    "Caption": "Encap\xe7alament",
    "Cell": "Cel\xb7la",
    "Cell padding": "Marge intern",
    "Cell properties": "Propietats de cel\xb7la",
    "Cell spacing": "Espai entre cel\xb7les",
    "Cell styles": "Estils de cel\xb7la",
    "Cell type": "Tipus de cel\xb7la",
    "Center": "Centre",
    "Characters": "Car\xe0cters",
    "Characters (no spaces)": "Car\xe0cters (sense espais)",
    "Circle": "Cercle",
    "Class": "Classe",
    "Clear formatting": "Eliminar format",
    "Close": "Tancar",
    "Code": "Codi",
    "Code sample...": "Mostra de codi...",
    "Code view": "Veure el codi",
    "Color Picker": "Selector de colors",
    "Color swatch": "Mostra de color",
    "Cols": "Columnes",
    "Column": "Columna",
    "Column clipboard actions": "Accions de columna del porta-retalls",
    "Column group": "Grup de columnes",
    "Column header": "Cap\xe7alera de columna",
    "Constrain proportions": "Conservar proporcions",
    "Copy": "Copia",
    "Copy column": "Copiar columna",
    "Copy row": "Copiar la fila",
    "Could not find the specified string.": "No es pot trobar el text especificat.",
    "Could not load emojis": "No s'han pogut carregar els emojis",
    "Count": "Compta",
    "Currency": "Moneda",
    "Current window": "Finestra actual",
    "Custom color": "Personalitzar el color",
    "Custom...": "Personalitza...",
    "Cut": "Retalla",
    "Cut column": "Retallar columna",
    "Cut row": "Retallar la fila",
    "Dark Blue": "Blau fosc",
    "Dark Gray": "Gris fosc",
    "Dark Green": "Verd fosc",
    "Dark Orange": "Taronja fosc",
    "Dark Purple": "Porpra fosc",
    "Dark Red": "Vermell fosc",
    "Dark Turquoise": "Turquesa fosc",
    "Dark Yellow": "Groc fosc",
    "Dashed": "Guions",
    "Date/time": "Data/hora",
    "Decrease indent": "Disminuir sagnat",
    "Default": "Predeterminat",
    "Delete accordion": "",
    "Delete column": "Suprimir columna",
    "Delete row": "Suprimir la fila",
    "Delete table": "Suprimir taula",
    "Dimensions": "Dimensions",
    "Disc": "Disc",
    "Div": "Div",
    "Document": "Document",
    "Dotted": "Puntejat",
    "Double": "Doble",
    "Drop an image here": "Deixar anar una imatge aqu\xed",
    "Dropped file type is not supported": "El tipus de fitxer deixat no \xe9s compatible",
    "Edit": "Editar",
    "Embed": "Incloure",
    "Emojis": "Emojis",
    "Emojis...": "Emojis...",
    "Error": "Error",
    "Error: Form submit field collision.": "Error: error en el camp d\u2019enviament del formulari.",
    "Error: No form element found.": "Error: no s'ha trobat l'element del formulari.",
    "Extended Latin": "Llat\xed ampliat",
    "Failed to initialize plugin: {0}": "No s'ha pogut inicialitzar el complement: {0}",
    "Failed to load plugin url: {0}": "No s'ha pogut carregar l\u2019URL del complement: {0}",
    "Failed to load plugin: {0} from url {1}": "No s'ha pogut carregar el complement: {0} de l\u2019URL {1}",
    "Failed to upload image: {0}": "No s'ha pogut carregar la imatge: {0}",
    "File": "Arxiu",
    "Find": "Cerca",
    "Find (if searchreplace plugin activated)": "Cercar (si el complement cercar-reempla\xe7ar est\xe0 activat)",
    "Find and Replace": "Cercar i reempla\xe7ar",
    "Find and replace...": "Cercar i reempla\xe7ar...",
    "Find in selection": "Buscar a la selecci\xf3",
    "Find whole words only": "Cercar nom\xe9s paraules completes",
    "Flags": "Banderes",
    "Focus to contextual toolbar": "Enfocar la barra d'eines contextual",
    "Focus to element path": "Enfocar la ruta d'elements",
    "Focus to menubar": "Enfocar la barra de men\xfa",
    "Focus to toolbar": "Enfocar la barra d'eines",
    "Font": "Tipus de font",
    "Font size {0}": "",
    "Font sizes": "Tamanys de font",
    "Font {0}": "",
    "Fonts": "Fonts",
    "Food and Drink": "Menjar i beure",
    "Footer": "Peu de p\xe0gina",
    "Format": "Format",
    "Format {0}": "Format {0}",
    "Formats": "Formats",
    "Fullscreen": "Pantalla completa",
    "G": "G",
    "General": "Generals",
    "Gray": "Gris",
    "Green": "Verd",
    "Green component": "Component verd",
    "Groove": "Solc",
    "Handy Shortcuts": "Dreceres \xfatils",
    "Header": "Encap\xe7alament",
    "Header cell": "Cel\xb7la de cap\xe7alera",
    "Heading 1": "Encap\xe7alament 1",
    "Heading 2": "Encap\xe7alament 2",
    "Heading 3": "Encap\xe7alament 3",
    "Heading 4": "Encap\xe7alament 4",
    "Heading 5": "Encap\xe7alament 5",
    "Heading 6": "Encap\xe7alament 6",
    "Headings": "Encap\xe7alaments",
    "Height": "Al\xe7ada",
    "Help": "Ajuda",
    "Hex color code": "Codi hexadecimal de color",
    "Hidden": "Ocult",
    "Horizontal align": "Alineaci\xf3 horitzontal",
    "Horizontal line": "L\xednia horitzontal",
    "Horizontal space": "Espai horitzontal",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "La ID ha de comen\xe7ar amb una lletra, seguida nom\xe9s per lletres, nombres, guions, punts, dos punts o guions baixos.",
    "Image is decorative": "La imatge \xe9s decorativa",
    "Image list": "Llista d'imatges",
    "Image title": "T\xedtol de la imatge",
    "Image...": "Imatge...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Error HTTP d'ImageProxy: No s'ha trobat l'ImageProxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Error HTTP d'ImageProxy: URL d'Image Proxy incorrecte",
    "ImageProxy HTTP error: Rejected request": "Error HTTP d'ImageProxy: Petici\xf3 rebutjada",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Error HTTP d'ImageProxy: Error d'ImageProxy desconegut",
    "Increase indent": "Augmentar sagnat",
    "Inline": "En l\xednia",
    "Insert": "Inserir",
    "Insert Template": "Inserir plantilla",
    "Insert accordion": "",
    "Insert column after": "Inserir columna despr\xe9s",
    "Insert column before": "Inserir columna abans",
    "Insert date/time": "Inserir data/hora",
    "Insert image": "Inserir imatge",
    "Insert link (if link plugin activated)": "Inserir enlla\xe7 (si el complement d'enlla\xe7 est\xe0 activat)",
    "Insert row after": "Inserir fila a sota",
    "Insert row before": "Inserir fila a sobre",
    "Insert table": "Inserir taula",
    "Insert template...": "Inserir plantilla...",
    "Insert video": "Inserir v\xeddeo",
    "Insert/Edit code sample": "Inserir/editar mostra de codi",
    "Insert/edit image": "Insereix/edita imatge",
    "Insert/edit link": "Inserir/editar l\u2019enlla\xe7",
    "Insert/edit media": "Inserir/editar multim\xe8dia",
    "Insert/edit video": "Inserir/editar v\xeddeo",
    "Inset": "Insert",
    "Invalid hex color code: {0}": "Codi hex de color inv\xe0lid: {0}",
    "Invalid input": "Entrada inv\xe0lida",
    "Italic": "Cursiva",
    "Justify": "Justificat",
    "Keyboard Navigation": "Navegaci\xf3 per teclat",
    "Language": "Idioma",
    "Learn more...": "Apr\xe8n m\xe9s...",
    "Left": "Esquerra",
    "Left to right": "D'esquerra a dreta",
    "Light Blue": "Blau clar",
    "Light Gray": "Gris clar",
    "Light Green": "Verd clar",
    "Light Purple": "Porpra clar",
    "Light Red": "Vermell clar",
    "Light Yellow": "Groc clar",
    "Line height": "Amplada de la l\xednia",
    "Link list": "Llista d'enlla\xe7os",
    "Link...": "Enlla\xe7...",
    "List Properties": "Propietats de la llista",
    "List properties...": "Propietats de la llista...",
    "Loading emojis...": "Carregant emojis...",
    "Loading...": "Carregant...",
    "Lower Alpha": "Lletra min\xfascula",
    "Lower Greek": "Lletra grega min\xfascula",
    "Lower Roman": "N\xfameros romans en min\xfascula",
    "Match case": "Fes coincidir maj\xfascules i min\xfascules",
    "Mathematical": "S\xedmbols matem\xe0tics",
    "Media poster (Image URL)": "Cartell de multim\xe8dia (URL d'imatge)",
    "Media...": "Multim\xe8dia...",
    "Medium Blue": "Blau mitj\xe0",
    "Medium Gray": "Gris mitj\xe0",
    "Medium Purple": "Violeta mitj\xe0",
    "Merge cells": "Fusionar cel\xb7les",
    "Middle": "Centre",
    "Midnight Blue": "Blau mitjanit",
    "More...": "M\xe9s\u2026",
    "Name": "Nom",
    "Navy Blue": "Blau mar\xed",
    "New document": "Nou document",
    "New window": "Finestra nova",
    "Next": "Seg\xfcent",
    "No": "No",
    "No alignment": "Sense alineament",
    "No color": "Sense color",
    "Nonbreaking space": "Espai cont\xednu",
    "None": "Cap",
    "Numbered list": "Llista enumerada",
    "OR": "O",
    "Objects": "Objectes",
    "Ok": "Acceptar",
    "Open help dialog": "Obrir el quadre de di\xe0leg d'ajuda",
    "Open link": "Obrir l'enlla\xe7",
    "Open link in...": "Obrir l'enlla\xe7 a...",
    "Open popup menu for split buttons": "Obre el men\xfa emergent per als botons dividits",
    "Orange": "Taronja",
    "Outset": "Relleu",
    "Page break": "Salt de p\xe0gina",
    "Paragraph": "Par\xe0graf",
    "Paste": "Enganxar",
    "Paste as text": "Enganxar com a text",
    "Paste column after": "Enganxar columna despr\xe9s",
    "Paste column before": "Enganxar columna abans",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Enganxar ara \xe9s en mode text pla. Els continguts s'enganxaran com a text pla fins que desactivis aquesta opci\xf3.",
    "Paste or type a link": "Enganxa o escriu un enlla\xe7",
    "Paste row after": "Enganxar fila a sota",
    "Paste row before": "Enganxar fila a sobre",
    "Paste your embed code below:": "Enganxeu el codi a sota:",
    "People": "Gent",
    "Plugins": "Complements",
    "Plugins installed ({0}):": "Complements instal\xb7lats ({0}):",
    "Powered by {0}": "Desenvolupat per {0}",
    "Pre": "Pre",
    "Preferences": "Par\xe0metres",
    "Preformatted": "Preformatat",
    "Premium plugins:": "Complements pr\xe8mium:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Visualitzaci\xf3 pr\xe8via",
    "Previous": "Anterior",
    "Print": "Imprimir",
    "Print...": "Imprimir...",
    "Purple": "Violeta",
    "Quotations": "Cites",
    "R": "R",
    "Range 0 to 255": "Rang de 0 a 255",
    "Red": "Vermell",
    "Red component": "Component vermell",
    "Redo": "Refer",
    "Remove": "Eliminar",
    "Remove color": "Eliminar el color",
    "Remove link": "Treure l\u2019enlla\xe7",
    "Replace": "Reempla\xe7ar",
    "Replace all": "Reempla\xe7a totes",
    "Replace with": "Reempla\xe7a per",
    "Resize": "Canviar mida",
    "Restore last draft": "Restaurar l'\xfaltim esborrany",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "\xc0rea de text enriquit",
    "Rich Text Area. Press ALT-0 for help.": "\xc0rea de Text enriquit. Premeu ALT-0 per obtenir ajuda.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\xc0rea de text amb format. Premeu ALT-F9 per mostrar el men\xfa, ALT F10 per la barra d'eines i ALT-0 per ajuda.",
    "Ridge": "Carena",
    "Right": "Dreta",
    "Right to left": "De dreta a esquerra",
    "Row": "Fila",
    "Row clipboard actions": "Accions de fila del porta-retalls",
    "Row group": "Grup de fila",
    "Row header": "Cap\xe7alera de fila",
    "Row properties": "Propietats de la fila",
    "Row type": "Tipus de fila",
    "Rows": "Files",
    "Save": "Desar",
    "Save (if save plugin activated)": "Desar (si el complement desar est\xe0 activat)",
    "Scope": "Abast",
    "Search": "Cerca",
    "Select all": "Seleccionar-ho tot",
    "Select...": "Selecciona\u2026",
    "Selection": "Selecci\xf3",
    "Shortcut": "Acc\xe9s directe",
    "Show blocks": "Mostrar blocs",
    "Show caption": "Mostrar encap\xe7alament",
    "Show invisible characters": "Mostrar car\xe0cters invisibles",
    "Size": "Mida",
    "Solid": "S\xf2lid",
    "Source": "Font",
    "Source code": "Codi font",
    "Special Character": "Car\xe0cter especial",
    "Special character...": "Car\xe0cters especials\u2026",
    "Split cell": "Dividir cel\xb7les",
    "Square": "Quadrat",
    "Start list at number": "N\xfamero on iniciar la llista",
    "Strikethrough": "Barrat",
    "Style": "Estil",
    "Subscript": "Sub\xedndex",
    "Superscript": "Super\xedndex",
    "Switch to or from fullscreen mode": "Canviar a o del mode de pantalla completa",
    "Symbols": "S\xedmbols",
    "System Font": "Font del sistema",
    "Table": "Taula",
    "Table caption": "T\xedtol de taula",
    "Table properties": "Propietats de taula",
    "Table styles": "Estils de taula",
    "Template": "Plantilla",
    "Templates": "Plantilles",
    "Text": "Text",
    "Text color": "Color del text",
    "Text color {0}": "",
    "Text to display": "Text per visualitzar",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "L'URL que has escrit sembla una adre\xe7a de correu electr\xf2nic. Vols afegir-li el prefix obligatori \xabmailto:\xbb?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "L'URL que has escrit sembla un enlla\xe7 extern. Vols afegir-li el prefix obligatori \xabhttp://\xbb?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Sembla que l\u2019URL que has introdu\xeft \xe9s un enlla\xe7 extern. Vols afegir el prefix https:// necessari?",
    "Title": "T\xedtol",
    "To open the popup, press Shift+Enter": "Per obrir la finestra emergent, premeu Maj.+Retorn",
    "Toggle accordion": "",
    "Tools": "Eines",
    "Top": "Part superior",
    "Travel and Places": "Viatges i llocs",
    "Turquoise": "Turquesa",
    "Underline": "Subratllat",
    "Undo": "Desfer",
    "Upload": "Pujar",
    "Uploading image": "Pujant imatge",
    "Upper Alpha": "Lletra maj\xfascula",
    "Upper Roman": "N\xfameros romans en maj\xfascula",
    "Url": "URL",
    "User Defined": "Definit per l'usuari",
    "Valid": "V\xe0lid",
    "Version": "Versi\xf3",
    "Vertical align": "Alineaci\xf3 vertical",
    "Vertical space": "Espai vertical",
    "View": "Veure",
    "Visual aids": "Assist\xe8ncia visual",
    "Warn": "Alerta",
    "White": "Blanc",
    "Width": "Amplada",
    "Word count": "Recompte de paraules",
    "Words": "Paraules",
    "Words: {0}": "Paraules: {0}",
    "Yellow": "Groc",
    "Yes": "S\xed",
    "You are using {0}": "Est\xe0s utilitzant {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Teniu canvis sense desar, esteu segur que voleu deixar-ho ara?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "El vostre navegador no suporta l'acc\xe9s directe al portaobjectes. Si us plau, feu servir les dreceres de teclat Ctrl+X/C/V.",
    "alignment": "alineaci\xf3",
    "austral sign": "signe de l\u2019austral",
    "cedi sign": "signe del cedi",
    "colon sign": "signe del col\xf3n",
    "cruzeiro sign": "signe del cruzeiro",
    "currency sign": "signe de la moneda",
    "dollar sign": "signe del d\xf2lar",
    "dong sign": "signe del dong",
    "drachma sign": "signe del dracma",
    "euro-currency sign": "signe de l'euro",
    "example": "exemple",
    "formatting": "format",
    "french franc sign": "signe del franc franc\xe8s",
    "german penny symbol": "signe del penic alemany",
    "guarani sign": "signe del guaran\xed",
    "history": "historial",
    "hryvnia sign": "signe de la hr\xedvnia",
    "indentation": "sagnat",
    "indian rupee sign": "signe de la rupia \xedndia",
    "kip sign": "signe del kip",
    "lira sign": "signe de la lira",
    "livre tournois sign": "signe de la lliura tornesa",
    "manat sign": "signe del manat",
    "mill sign": "signe del mill",
    "naira sign": "signe de la naira",
    "new sheqel sign": "signe del nou x\xe9quel",
    "nordic mark sign": "signe del marc n\xf2rdic",
    "peseta sign": "signe de la pesseta",
    "peso sign": "signe del peso",
    "ruble sign": "signe del ruble",
    "rupee sign": "signe de la rupia",
    "spesmilo sign": "signe de l\u2019spesmilo",
    "styles": "estils",
    "tenge sign": "signe del tenge",
    "tugrik sign": "signe del t\xf6gr\xf6g",
    "turkish lira sign": "signe de la lira turca",
    "won sign": "signe del won",
    "yen character": "signe del ien",
    "yen/yuan character variant one": "variaci\xf3 1 del signe del ien/iuan",
    "yuan character": "signe del iuan",
    "yuan character, in hong kong and taiwan": "signe del iuan en Hong Kong i Taiwan",
    "{0} characters": "{0} car\xe0cters",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} paraules"
});